import React, { useEffect, useState } from "react";
import useStyles from "./styles";
import { __t } from "@core/translation/translation";
import { Grid, Paper, Popover } from "@material-ui/core";
import TabsPanel from "@components/TabsPanel";
import Typography from "@components/Typography";
import LimitOrder from "./LimitOrder";
import CurrentMarketPrice from "./CurrentMarketPrice";
import clsx from "clsx";
import Button from "@components/Button";
import user from "@api/user";

const MarketOrder = () => {
  const classes = useStyles();
  const [state, setState] = useState({
    open: false,
    anchorEl: false,
    data: [],
    isFetched: false,
  });

  useEffect(() => {
    user
      .getUserLimitationsInfo()
      .then((data) => {
        setState((prevState) => ({
          data: data.content,
          isFetched: true,
        }));
      })
      .catch((data) => {});
  }, []);

  const handleOpen = (event) => {
    setState((prevState) => ({
      ...prevState,
      open: true,
      anchorEl: event.target,
    }));
  };
  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      open: null,
      anchorEl: null,
    }));
  };
  const tabs = [
    {
      label: __t("Limit Order"),
      component: <LimitOrder />,
    },
    {
      label: __t("Current Market Price"),
      component: <CurrentMarketPrice />,
    },
  ];
  return (
    <>
      <TabsPanel
        tabs={tabs}
        className={classes.appBar}
        smallTabs={true}
        size={"small"}
        extraText={
          <div className={classes.extraTextContainer}>
            <Typography variant="3xs" color="teal.main">
              {__t("How do I trade?")}
            </Typography>
            <div
              onClick={handleOpen}
              className={clsx(
                state.open ? "icon-x" : "icon-more-vertical",
                classes.icon
              )}
            />
          </div>
        }
      />
      {state.open && (
        <Popover
          open={state.open}
          anchorEl={state.anchorEl}
          onClose={handleClose}
          className={classes.popOverContainer}
          anchorOrigin={{
            vertical: "top",
            horizontal: "left",
          }}
          transformOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <Paper className={classes.popOver} elevation={0}>
            <Grid
              container
              direction="column"
              justify="space-between"
              spacing={10}
            >
              <Grid item container direction="row" justify="space-between">
                <Grid item>
                  <Typography color="secondary.tint15">
                    {__t("Transaction Fee At Your User Level:")}
                  </Typography>
                </Grid>
                <Grid item>
                  <Typography>%</Typography>
                  <Typography isBold>
                    {state.isFetched ? state.data.tradeFee : 0.35}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color="default"
                  size="small"
                  endIcon={<span className="icon-chevron-left" />}
                >
                  <Typography>{__t("Fees")}</Typography>
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Popover>
      )}
    </>
  );
};

export default MarketOrder;
